/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'rovo-agents-scenario-onboarding': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--rovo-agents-scenario-onboarding/placements/in-app/screen-space-flags/render'
			),
	),
};
